'use client';

import { useAuthenticationStore } from '@/provider/customs/useAuthenticationStore';
import {
    AuthenticateInfo,
    AuthExtendedInfo,
    GetInfoResponse,
} from '@/server/api/v1/auth/types';
import { useEffect } from 'react';
import { useEmployeeResolver } from './use-employee-store';

/**Hàm đón session từ server và xử lý thông tin tài khoản và nhân viên */
export const useSessionAuthenticate = (
    info: GetInfoResponse | null,
    extendedInfo?: AuthExtendedInfo
) => {
    const { setAuth, auth, isAuthenticated, setIsAuthenticated } =
        useAuthenticationStore((x) => x);
    const empInfo = useEmployeeResolver(info?.authData ?? null);

    // handle data-here if need
    useEffect(() => {
        const cloneAuthData = { ...info?.authData } as AuthenticateInfo;

        if (info?.session?.user) {
            const { isAdministrator, userId, customerId, accountId } =
                info.session.user;
            cloneAuthData.UserId = userId;
            cloneAuthData.IsAdmin = isAdministrator;
            cloneAuthData.CustomerId = customerId;
            cloneAuthData.AccountId = accountId;
            cloneAuthData.SessionToken = info.session.user.sessionToken;

            if (
                cloneAuthData.ExtraInfo?.CustomerInfo &&
                cloneAuthData.ExtraInfo?.StudentInfo
            ) {
                cloneAuthData.ExtraInfo.CustomerInfo.Student = {
                    ...cloneAuthData.ExtraInfo.StudentInfo,
                };
            }
        }

        setIsAuthenticated(!!cloneAuthData && !info?.isSessionExpiredOrError);
        setAuth(cloneAuthData ?? undefined);
    }, [extendedInfo?.CustomerInfo, info, setAuth, setIsAuthenticated]);

    return { isAuthenticated, authData: auth, empInfo };
};
